import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

const adminModules = [
  { label: "Anfragen", href: "/admin/inquiries" },
  { label: "Angebote", href: "/admin/offers" },
  { label: "Mitarbeiter", href: "/admin/mitarbeiter" },
  { label: "Kurse", href: "/admin/courses" },
  { label: "Kursplan", href: "/admin/kursplan" },
  { label: "Wellness", href: "/admin/wellness" },
  { label: "Öffnungszeiten", href: "/admin/opening-hours" },
  { label: "Pakete", href: "/admin/packages" },
  { label: "Sonstiges", href: "/admin/sonstiges" },
];

export function AdminNavbar() {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      <aside className="hidden md:fixed md:inset-y-0 md:left-0 md:z-40 md:flex md:w-64 md:flex-col md:border-r md:border-border/10 md:bg-black/40 md:backdrop-blur-sm">
        <div className="flex items-center border-b border-border/10 px-6 py-5">
          <Link to="/admin" className="flex items-center shrink-0">
            <img
              src="/logo.webp"
              alt="Sepps Fitness"
              width={340}
              height={100}
              className="h-8 w-auto"
            />
          </Link>
        </div>

        <nav className="flex flex-1 flex-col gap-1 px-4 py-5">
          {adminModules.map((module) => {
            const isActive = pathname === module.href;
            return (
              <Button
                key={module.href}
                variant="ghost"
                asChild
                className={cn(
                  "justify-start rounded-lg px-4 text-sm font-medium transition-colors hover:bg-white/5",
                  isActive
                    ? "bg-white/5 text-cyan-400 hover:text-cyan-400"
                    : "text-foreground/70 hover:text-cyan-400"
                )}
              >
                <Link to={module.href}>{module.label}</Link>
              </Button>
            );
          })}
        </nav>
      </aside>

      <header className="fixed top-0 z-50 w-full border-b border-border/10 bg-black/40 backdrop-blur-sm md:hidden">
        <div className="flex h-16 items-center gap-6 px-4 md:px-6">
          <Link to="/admin" className="flex items-center shrink-0">
            <img
              src="/logo.webp"
              alt="Sepps Fitness"
              width={340}
              height={100}
              className="h-8 w-auto"
            />
          </Link>

          <div className="ml-auto">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-white">
                  <Menu className="h-6 w-6" />
                  <span className="sr-only">Menü öffnen</span>
                </Button>
              </SheetTrigger>
              <SheetContent className="bg-background border-l border-white/10">
                <div className="mt-8 flex flex-col gap-6">
                  <Link to="/admin" className="mb-4 flex items-center">
                    <img
                      src="/logo.webp"
                      alt="Sepps Fitness"
                      width={200}
                      height={60}
                      className="h-8 w-auto"
                    />
                  </Link>
                  <nav className="flex flex-col gap-2">
                    {adminModules.map((module) => {
                      const isActive = pathname === module.href;
                      return (
                        <SheetClose key={module.href} asChild>
                          <Link
                            to={module.href}
                            className={cn(
                              "rounded-md px-4 py-3 text-base font-medium transition-colors hover:bg-white/5",
                              isActive
                                ? "bg-white/5 text-cyan-400"
                                : "text-foreground/70 hover:text-cyan-400"
                            )}
                          >
                            {module.label}
                          </Link>
                        </SheetClose>
                      );
                    })}
                  </nav>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
    </>
  );
}
